import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { RouteType } from "src/app/models/enum";
import { FeedbackTaskDetail, FeedbackTemplateSnapshot } from "src/app/models/models";
import { HttpService } from "src/app/shared/services/http.service";
import { LoaderService } from "src/app/shared/services/loader.service";
import { SharedService } from "src/app/shared/services/shared.service";

@Component({
	selector: "app-checklist-feedback-route",
	templateUrl: "./checklist-feedback-route.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ChecklistFeedbackRouteComponent implements OnInit, OnDestroy {
	taskId = "";
	trainingAssessmentId = "";
	isStandalone = false;
	feedbackTask: FeedbackTaskDetail | null = null;
	template: FeedbackTemplateSnapshot | null = null;
	submitted = false;
	loadError = "";

	private routeSub?: Subscription;
	private loadSub?: Subscription;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private httpService: HttpService,
		private loaderService: LoaderService,
		private sharedService: SharedService,
	) {}

	ngOnInit(): void {
		this.sharedService.setActivePage(RouteType.CHECKLIST);
		this.routeSub = this.route.params.subscribe((params) => {
			this.taskId = params["taskId"] ?? "";
			this.trainingAssessmentId = params["trainingAssessmentId"] ?? "";
			this.isStandalone = !!this.taskId && !this.trainingAssessmentId;
			this.loadFeedback();
		});
	}

	ngOnDestroy(): void {
		this.routeSub?.unsubscribe();
		this.loadSub?.unsubscribe();
	}

	loadFeedback(): void {
		this.loadError = "";
		this.feedbackTask = null;
		this.template = null;
		this.submitted = false;
		this.loaderService.setLoading(true);

		this.loadSub?.unsubscribe();
		const request$ = this.isStandalone
			? this.httpService.getStandaloneFeedbackTask(this.taskId)
			: this.httpService.getFeedbackTask(this.trainingAssessmentId);

		this.loadSub = request$.subscribe({
			next: (resp) => {
				const detail = (resp?.data ?? resp) as FeedbackTaskDetail | null;
				if (!detail?.template) {
					this.loadError = "No feedback questionnaire is available.";
					this.loaderService.setLoading(false);
					return;
				}

				this.feedbackTask = detail;
				this.template = detail.template;
				this.submitted = detail.submitted || detail.status === "completed";
				this.loaderService.setLoading(false);
			},
			error: () => {
				this.loadError = "Unable to load feedback questionnaire.";
				this.loaderService.setLoading(false);
			},
		});
	}

	goBack(): void {
		this.router.navigate([RouteType.CHECKLIST]);
	}

	onCompleted(): void {
		this.submitted = true;
		this.router.navigate([RouteType.CHECKLIST]);
	}
}
